export default __webpack_public_path__ + "static/media/CDJR-rotating-logos-BLK.0456a99c.gif";